module.exports = __webpack_public_path__ + "img/GQ.946b27f4.svg";